import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  dots: {
    display: 'inline-block',
    width: 20,
    textAlign: 'left',
  },
}));

const LoadingDots = ({ interval = 500, maxDots = 3 }) => {
  const classes = useStyles();
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setDotCount((prev) => (prev < maxDots ? prev + 1 : 0));
    }, interval);

    return () => clearInterval(timer);
  }, [interval, maxDots]);

  return (
    <span className={classes.dots}>
      {'.'.repeat(dotCount)}
    </span>
  );
};

export default LoadingDots;
